import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

// 信息列表
export function recordList (data) {
  return request({
    url: baseURL + 'record/recordList',
    method: 'post',
    data: data
  })
}
// 活动发布
export function activeAdd (data) {
  return request({
    url: baseURL + 'active/add',
    method: 'post',
    data: data
  })
}
// 活动查询

export function activeList (data) {
  return request({
    url: baseURL + 'active/list',
    method: 'post',
    data: data
  })
}



// 信息发布
export function infoAdd (data) {
  return request({
    url: baseURL + '/order/orderList',
    method: 'post',
    data: data
  })
}
// 信息更改
export function updateInfo (data) {
  return request({
    url: baseURL + '/info/update',
    method: 'post',
    data: data
  })
}

// 信息删除
export function deleteInfo (data) {
  return request({
    url: baseURL + '/info/delete',
    method: 'post',
    data: data
  })
}
// 信息帮助
export function infoHelp (data) {
  return request({
    url: baseURL + '/info/help',
    method: 'post',
    data: data
  })
}

// 信息帮助
export function infoMyHelp (data) {
  return request({
    url: baseURL + '/info/mYhelp',
    method: 'post',
    data: data
  })
}

// 信息帮助
export function judge (data) {
  return request({
    url: baseURL + '/info/judge',
    method: 'post',
    data: data
  })
}
// 统计
export function tongji (data) {
  return request({
    url: baseURL + '/info/tongji',
    method: 'post',
    data: data
  })
}






// WEBPACK FOOTER //
// ./src/api/record/index.js